// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6147 ? "aa2cb1d1" : chunkId) + "." + {"6147":"a8d04443f2640d2a6799","8508":"1dcfd83c9cd03609638b"}[chunkId] + ".js";
};